import common from './src/locales/common';
import customer from './src/locales/customer';
import mobile from './src/locales/mobile';
import mobilePro from './src/locales/mobile-pro';
import mobileUI from './src/locales/mobile-ui';
import pro from './src/locales/pro';
import web from './src/locales/web';
import webCustomerArea from './src/locales/web-customer-area';
import webItc from './src/locales/web-itc';
import i18n, * as core from './src/translator';

// Plain consts, not `export *`: babel turns re-exports into getters, and jest.spyOn on this barrel needs writable properties.
export const { getI18nLocale, getSupportedLocale, setI18nConfig, setI18nLocale, setI18nLocaleConfig, translate } = core;
export type { Values } from './src/translator';
export type { Locale, Translations } from './src/types';
export default i18n;
export { common, customer, mobile, mobilePro, mobileUI, pro, web, webCustomerArea, webItc };
